import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

import { FixSpellingIcon } from '../../../../icons/prompt/fixSpelling';
import { ImproveWritingIcon } from '../../../../icons/prompt/improveWriting';
import { type ConvoAiFeatureId } from '../../../../utils/request/types';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

export const improveWriting: () => EditorPluginAIConfigItem = () => {
	let featureId: ConvoAiFeatureId = 'improve_writing';
	let adfPrompt = false;
	if (expValEqualsNoExposure('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf')) {
		featureId = 'improve_writing_adf_gemini20flash';
		adfPrompt = true;
	} else if (
		expValEqualsNoExposure('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_personalisation')
	) {
		featureId = 'improve_writing_adf_v103';
		adfPrompt = true;
	}

	return {
		key: CONFIG_ITEM_KEYS.IMPROVE_WRITING,
		title: aiConfigItemMessages.improveWritingTitle,
		description: aiConfigItemMessages.improveWritingDescription,
		icon: () => <ImproveWritingIcon />,
		intentSchemaId: 'improve_quality_intent_schema.json',
		featureId,
		adfPrompt,
		actions: {
			empty: [
				createInsertBelow({ appearance: 'secondary' }),
				createReplace({ appearance: 'primary' }),
			],
			selection: [
				createInsertBelow({ appearance: 'secondary' }),
				createReplace({ appearance: 'primary' }),
			],
		},
		getBackendModel: () => {
			return 'assistance-service';
		},
		canToggleDiffPreview: true,
	};
};

export const improveWritingWithOptions: () => EditorPluginAIConfigItemWithOptions = () => ({
	config: improveWriting(),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});

export const fixSpellingAndGrammar: () => EditorPluginAIConfigItem = () => ({
	key: CONFIG_ITEM_KEYS.FIX_SPELLING_AND_GRAMMAR,
	title: aiConfigItemMessages.fixSpellingGrammarTitle,
	description: aiConfigItemMessages.fixSpellingGrammarDescription,
	icon: () => <FixSpellingIcon />,
	intentSchemaId: 'grammar_spelling_intent_schema.json',
	featureId: expValEqualsNoExposure('platform_editor_ai_ct_sg_adf_streaming', 'isEnabled', true)
		? 'fix_spelling_grammar_adf'
		: 'fix_spelling_grammar',
	adfPrompt: expValEqualsNoExposure('platform_editor_ai_ct_sg_adf_streaming', 'isEnabled', true),
	actions: {
		empty: [createReplace({ appearance: 'primary' })],
		selection: [createReplace({ appearance: 'primary' })],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});

export const fixSpellingAndGrammarWithOptions: () => EditorPluginAIConfigItemWithOptions = () => ({
	config: fixSpellingAndGrammar(),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
